<template>
  <article>
    <bee :clientId="tenant.beeClientId"
          :clientSecret="tenant.beeClientSecret" />
  </article>
</template>

<script>
import Bee from 'components/partials/Bee'
import L from 'services/Localization'
import notifications from 'mixins/notifications'
import { mapGetters } from 'vuex'

export default {
  name: 'template',
  components: { Bee },
  mixins: [notifications],
  data() {
    return {
      loading: false,
      title: 'Create',
      L: L,
      model: {
        id: '',
        name: ''
      },
      tenant: {
        name: '',
        description: '',
        image: {},
        beeClientId: '',
        beeClientSecret: ''
      }
    }
  },
  beforeCreate() {
    if (this.$route.params.id) {
      this.$store.dispatch('getTemplate', this.$route.params.id).then(() => {
        this.mapFromState()
      })

      this.$store.dispatch('getTenantSession').then(() => {
        _.assign(this.tenant, this.currentTenant)
      })
    }
  },
  computed: {
    ...mapGetters({
      template: 'activeTemplate',
      currentTenant: 'getCurrentTenant'
    })
  },
  methods: {
    mapFromState() {
      _.assign(this.model, this.template)
      if (this.template) {
        this.title = this.template.subject
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// TemplateEditor.vue?179e999b